import { useState } from "react";
import { Heart, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";

export const TipPrompt = ({ trip: initial, onDone }) => {
  const [local, setLocal] = useState(null);
  const trip = local || initial;
  const [custom, setCustom] = useState("");
  const [busy, setBusy] = useState(false);
  if (trip.kind === "rental" || trip.status !== "completed" || !trip.driver_id) return null;
  if (trip.tip?.status === "paid") return <p data-testid="tip-done" className="text-sm text-emerald-300">Tip {money(trip.tip.amount)} sent — 100% goes to {trip.driver_first_name || "your driver"}.</p>;
  const base = trip.fare.subtotal - (trip.fare.tolls?.amount || 0);
  const send = async (body) => {
    setBusy(true);
    try { const { data } = await api.post(`/trips/${trip.id}/tip`, body); data.tip?.status === "paid" ? toast.success("Thank you for the tip!") : toast.error("Payment due"); setLocal(data); onDone?.(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="tip-prompt" className="rounded-xl border border-amber-500/25 bg-amber-400/5 p-4">
      <p className="flex items-center gap-2 text-sm text-amber-100"><Heart className="h-4 w-4 text-amber-400" /> Add a tip for {trip.driver_first_name || "your driver"}? 100% goes to them.</p>
      {trip.tip?.status === "payment_due" && <p data-testid="tip-payment-due" className="mt-1 text-xs text-red-300">Tip {money(trip.tip.amount)} · Payment due</p>}
      <div className="mt-3 flex flex-wrap gap-2">
        {[15, 20, 25].map((p) => (
          <button key={p} data-testid={`tip-${p}`} disabled={busy} onClick={() => send({ percent: p })} className="btn-outline-gold !px-4 !py-2 text-sm">{p}% · {money(base * p / 100)}</button>
        ))}
        <div className="flex gap-2">
          <input type="number" min="1" step="0.01" data-testid="tip-custom-input" className="lux-input !w-28 !py-2" placeholder="Custom $" value={custom} onChange={(e) => setCustom(e.target.value)} />
          <button data-testid="tip-custom-button" disabled={busy || !custom} onClick={() => send({ amount: Number(custom) })} className="btn-gold !px-4 !py-2 text-sm">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Tip"}</button>
        </div>
      </div>
    </div>
  );
};
